import { useDeviceInfo } from '@musinsa/packages-device-detection';

declare const window: Window;

export type AppMessageCommand =
  | 'loginFacebook'
  | 'loginKakao'
  | 'loginNaver'
  | 'showContact'
  | 'sendKakaoMessage'
  | 'marketing/tracker'
  | 'setCartCount'
  | 'setUserProperties'
  | 'showToast'
  | 'logout';

export type AppMessage = Record<string, unknown>;

export const useSendMessage = () => {
  const { isIos, isAndroid, isWebview } = useDeviceInfo();

  const sendAppMessage = (command: AppMessageCommand, payload: AppMessage = {}): boolean => {
    if (!isWebview) {
      return false;
    }

    try {
      if (isIos) {
        window.webkit?.messageHandlers?.[command]?.postMessage?.(payload);
        return true;
      }

      if (isAndroid) {
        window.android29cm?.[command]?.(JSON.stringify(payload));
        return true;
      }
    } catch (err) {
      console.warn('[useSendMessage] sendAppMessage failed', err);
    }

    return false;
  };

  const sendAppSchemeMessage = (key: string, message?: string) => {
    if (!isWebview) {
      return;
    }

    let url = 'app29cm://webappif/';
    if (key) {
      url += key;
    }
    if (message) {
      url += `?${message}`;
    }
    let iframe: HTMLIFrameElement | null = document.createElement('iframe');
    iframe.setAttribute('src', url);

    document.documentElement.appendChild(iframe);
    iframe.parentNode?.removeChild(iframe);
    iframe = null;
  };

  return {
    sendAppMessage,
    sendAppSchemeMessage,
  };
};

type Android29CM = Record<AppMessageCommand, (payload: string) => void>;

interface Webkit {
  messageHandlers: Record<AppMessageCommand, WebkitMessageHandler>;
}

interface WebkitMessageHandler {
  postMessage: (payload: AppMessage) => void;
}

interface Window {
  webkit?: Webkit;
  android29cm?: Android29CM;
}
